import { Text } from '@/ui-kit'
import { formatBytes, formatNumber } from '@/utils'
import { CloudUpload, Star, Users, Zap } from 'lucide-react'
import type { Mission } from '../api/models'

type MissionStatsProps = {
  mission: Mission
}

export const MissionStats = ({ mission }: MissionStatsProps) => {
  return (
    <>
      <div className="flex gap-6">
        <div className="text-gray-90 flex items-center gap-2">
          <Users size={15} className="text-gray-80 shrink-0" />
          <Text type="body2-regular">{formatNumber(mission.view.joined, 0)} joined</Text>
        </div>
        {mission.type === 'FILE_UPLOAD' && mission.view.uploadedBytes > 0 && (
          <div className="text-gray-90 flex items-center gap-2">
            <CloudUpload size={15} className="text-gray-80 shrink-0" />
            <Text type="body2-regular">Uploaded {formatBytes(mission.view.uploadedBytes)}</Text>
          </div>
        )}
      </div>
      {(mission.view.accruedReward > 0 || (mission.type === 'WEBSITE_LOGIN' && mission.view.earnedPoints > 0)) && (
        <>
          <div className="text-gray-70 mt-4 flex items-start gap-2">
            <Star size={16} className="text-green mt-1 shrink-0" />
            You got {formatNumber(mission.view.accruedReward, 0)} points
          </div>
          {mission.type === 'WEBSITE_LOGIN' && mission.view.earnedPoints > 0 && (
            <div className="text-gray-70 flex items-start gap-2">
              <Zap size={16} className="text-green mt-1 shrink-0" />
              You earned extra {formatNumber(mission.view.earnedPoints, 0)} points
            </div>
          )}
        </>
      )}
    </>
  )
}
